<template>
  <teleport to="body">
  <div class="modal fade" id="createScheduleModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">
                    Criar
                    <span v-if="currentTab==='schedule'">agendamento</span>
                    <span v-else>bloqueio</span>
                  </h1>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              
              <div class="modal-body">
                <!-- tabs -->
                <ul class="nav nav-tabs mb-3">
                  <li class="nav-item">
                    <a href="#" class="nav-link" :class="{active: currentTab==='schedule'}" @click.prevent="currentTab='schedule'">Agendamento</a>
                  </li>
                  <li class="nav-item">
                    <a href="#" class="nav-link" :class="{active: currentTab==='block'}" @click.prevent="currentTab='block'">Bloqueio</a>
                  </li>
                </ul>

                <h1 class="modal-title fs-5">
                  Data: {{ formattedDate }} ({{ weekDay }})
                </h1>

                <div v-if="allowDateSelection" class="mt-3 mb-3">
                  <label for="create-schedule-date" class="form-label">Data:</label>
                  <input
                    ref="dateInput"
                    id="create-schedule-date"
                    type="text"
                    class="form-control datepicker"
                    placeholder="Selecione a data"
                  >
                </div>

                <div v-if="currentTab==='schedule'">
                  <div class="mt-3 mb-3">
                    <label for="time-service" class="form-label">Horário:</label>
                    <input
                      v-model="selectedTime"
                      type="time"
                      :class="['form-control', {'is-invalid': validationErrors.selectedTime}]"
                      placeholder="hh:mm"
                      maxlength="5"
                      @input="maskTime"
                    >
                    <div class="invalid-feedback" v-if="validationErrors.selectedTime">{{ validationErrors.selectedTime }}</div>
                  </div>
                  
                  <div class="header-left-side justify-content-center justify-content-md-start d-flex flex-column col-12 mb-20">
                    <label for="category" class="form-label">Categoria:</label>
                    <select v-model="selectedCategory" :class="['form-select', {'is-invalid': validationErrors.selectedCategory}]">
                      <option disabled value="">Selecione a categoria</option>
                      <option v-for="cat in getCategories" :key="cat.id" :value="cat.id">
                        {{ cat.name }}
                      </option>
                    </select>
                    <div class="invalid-feedback" v-if="validationErrors.selectedCategory">{{ validationErrors.selectedCategory }}</div>
                  </div>

                  <div v-if="availableSubcategories.length" class="mb-3">
                    <label for="schedule_subcategory" class="form-label">Subcategoria:</label>
                    <select id="schedule_subcategory" v-model="selectedSubcategory" class="form-select">
                      <option disabled value="">Selecione a subcategoria</option>
                      <option v-for="subcategory in availableSubcategories" :key="subcategory.id" :value="subcategory.id">
                        {{ subcategory.name }}
                      </option>
                    </select>
                  </div>

                  <div class="header-left-side justify-content-center justify-content-md-start d-flex flex-column col-12 mb-20">
                    <label for="category" class="form-label">Serviço:</label>
                    <select v-model="selectedService" :class="['form-select', {'is-invalid': validationErrors.selectedService}]" :disabled="!getServices.length">
                      <option disabled value="">Selecione o serviço</option>
                      <option v-for="service in getServices" :key="service.id" :value="service.id">
                        {{ service.name }}
                      </option>
                    </select>
                    <div class="invalid-feedback" v-if="validationErrors.selectedService">{{ validationErrors.selectedService }}</div>
                  </div>

                  <div class="header-left-side justify-content-center justify-content-md-start d-flex flex-column col-12 mb-20">
                    <label for="category" class="form-label">Atendente:</label>
                    <select v-model="selectedUser" :class="['form-select', {'is-invalid': validationErrors.selectedUser}]" :disabled="!getUsersByCategory.length">
                      <option disabled value="">Selecione o atendente</option>
                      <option v-for="user in getUsersByCategory" :key="user.id" :value="user.id">
                        {{ user.name }}
                      </option>
                    </select>
                    <div class="invalid-feedback" v-if="validationErrors.selectedUser">{{ validationErrors.selectedUser }}</div>
                  </div>


                  <div class="header-left-side justify-content-center justify-content-md-start d-flex flex-column col-12 mb-20">
                    <label for="selectContacts" class="form-label">Cliente:</label>
                    <div class="d-flex align-items-start gap-2 w-100">
                      <div :class="['position-relative flex-grow-1', {'is-invalid': validationErrors.selectedContacts}]">
                        <multiselect
                        class="create-schedule-multiselect"
                        ref="contactSelect"
                        v-model="selectedContacts"
                        :options="getContacts"
                        :searchable="true"
                        :loading="isLoading"
                        :internal-search="false"
                        :custom-label="formatOption"
                        :taggable="true"
                        label="phone"
                        track-by="phone"
                        no-options-text="Nenhum contato encontrado."
                        no-result-text="Nenhum resultado para sua busca."
                        placeholder="Buscar contatos..."
                        @search-change="debouncedFetchContacts"
                        @tag="addCustomContact"
                        @close="handleBlur"
                        @blur="handleBlur"
                        :close-on-select="true"
                        id="selectContacts"
                        :class="{'is-invalid': validationErrors.selectedContacts}"
                      >
                        <template #noOptions>
                          <div>
                            Comece a digitar para buscar contatos.
                          </div>
                        </template>
                        <template #noResult>
                          Nenhum contato encontrado
                        </template>
                      </multiselect>
                      <div class="invalid-feedback d-block" v-if="validationErrors.selectedContacts">{{ validationErrors.selectedContacts }}</div>
                      </div>
                      <button type="button" class="btn btn-outline-secondary d-flex align-items-center justify-content-center" @click="pasteAndSearchContact" title="Colar e buscar" style="height: 42px; width: 42px;">
                        <i class="ph ph-clipboard fs-20"></i>
                      </button>
                    </div>
                  </div>

                  <div v-if="selectedContacts && selectedContacts.custom" class="header-left-side justify-content-center justify-content-md-start d-flex flex-column col-12 mb-20">
                    <label class="form-label">Cliente não encontrado - crie novos dados</label>
                    <input
                      v-model="newClientName"
                      type="text"
                      :class="['form-control mb-2', {'is-invalid': validationErrors.newClientName}]"
                      placeholder="Nome do cliente (obrigatório)"
                    />
                    <div class="invalid-feedback" v-if="validationErrors.newClientName">{{ validationErrors.newClientName }}</div>
                    <input
                      v-model="newClientBirthdate"
                      type="text"
                      :class="['form-control', {'is-invalid': validationErrors.newClientBirthdate}]"
                      placeholder="Data de nascimento (opcional) ex: DD/MM/AAAA"
                      maxlength="10"
                      @input="maskDate"
                    />
                    <div class="invalid-feedback" v-if="validationErrors.newClientBirthdate">{{ validationErrors.newClientBirthdate }}</div>
                  </div>

                  <div class="header-left-side justify-content-center justify-content-md-start d-flex flex-column col-12 mb-20">
                    <label for="paymentMethod" class="form-label">Forma de Pagamento (Opcional):</label>
                    <select v-model="selectedPaymentMethod" class="form-select" id="paymentMethod">
                      <option :value="null">Nenhuma</option>
                      <option v-for="method in getPaymentMethods" :key="method.id" :value="method.id">
                        {{ method.name }} <span v-if="method.fee">(Taxa: {{ method.fee }}%)</span>
                      </option>
                    </select>
                  </div>
                </div>

                <!-- blocking form -->
                <div v-else>
                  <!-- choose user to block -->
                    <div class="header-left-side justify-content-center justify-content-md-start d-flex flex-column col-12 mb-20">
                    <label for="category" class="form-label">Atendente:</label>
                    <select v-model="selectedUser" class="form-select" :disabled="!getUsers.length">
                      <option disabled value="">Selecione o atendente</option>
                      <option v-for="user in getUsers" :key="user.id" :value="user.id">
                        {{ user.name }}
                      </option>
                    </select>
                  </div>

                  <div class="mb-3">
                    <label class="form-label" for="reasonBlocker">Motivo de bloqueio (opcional):</label>
                    <input class="form-control" id="reasonBlocker" v-model="reasonBlocker" autocomplete="off">
                  </div>

                  <div class="form-check mb-3">
                    <input class="form-check-input" type="checkbox" id="blockEntire" v-model="blockEntireDay">
                    <label class="form-check-label" for="blockEntire">
                      Bloquear o dia inteiro
                    </label>
                  </div>

                  <div v-if="!blockEntireDay" class="d-flex gap-2 mb-3">
                    <div class="flex-fill">
                      <label for="blockStart" class="form-label">Início</label>
                      <input
                        v-model="blockStart"
                        type="time"
                        class="form-control"
                        maxlength="5"
                        @input="maskTime"
                      />
                    </div>
                    <div class="flex-fill">
                      <label for="blockEnd" class="form-label">Fim</label>
                      <input
                        v-model="blockEnd"
                        type="time"
                        class="form-control"
                        maxlength="5"
                        @input="maskTime"
                      />
                    </div>
                  </div>
                </div>





              </div>

              <div v-if="Object.keys(validationErrors).length > 0" class="alert alert-danger fs-md-15 fs-lg-16 me-3 ms-3" role="alert">
                Verifique se todos os campos obrigatórios estão preenchidos.
              </div>

              <div class="modal-footer">
                  <button type="button" class="col-12 col-sm-3 btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                  <button ref="button_submit_create_schedule" type="button" class="col-12 col-sm-4 btn btn-primary" @click="confirmSchedule">
                    Confirmar {{ currentTab === 'schedule' ? 'agendamento' : 'bloqueio' }}
                  </button>
              </div>
          </div>
      </div>
  </div>

  <!-- Modal de Conflito -->
  <div class="modal fade" id="conflictModal" tabindex="-1" aria-hidden="true" style="z-index: 1060;">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5 text-warning">
                    Aviso de Conflito de Horário
                  </h1>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <p>Já existe um agendamento para este horário. Deseja criar o agendamento mesmo assim?</p>
              </div>
              <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" @click="closeConflictModal">Não, mudar horário</button>
                  <button ref="button_submit_conflict" type="button" class="btn btn-warning" @click="confirmWithConflict">Sim, criar mesmo assim</button>
              </div>
          </div>
      </div>
  </div>
  </teleport>
</template>

<script>

import api from '../../config/axios.js';
import { mapActions, mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import moment from 'moment';
import flatpickr from "flatpickr";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";

export default {
  name: "CreateScheduleModal",
  props: {
    date: {
      type: String,
      required: true
    },
    // optional initial values when opening the modal programmatically
    initialTime: {
      type: String,
      default: ""
    },
    initialCategory: {
      type: [String, Number],
      default: null
    },
    initialService: {
      type: [String, Number],
      default: null
    },
    initialUser: {
      type: [String, Number],
      default: null
    },
    initialClient: {
      type: Object,
      default: null
    },
    allowDateSelection: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Multiselect
  },
  data () {
      return {
        currentTab: 'schedule', // 'schedule' or 'block'
        selectedTime: "",
        selectedCategory: null,
        selectedSubcategory: null,
        selectedService: null,
        selectedUser: null,
        selectedContacts: null,
        selectedPaymentMethod: null,
        blockEntireDay: false,
        blockStart: '',
        blockEnd: '',
        isLoading: false,
        newClientName: '',
        newClientBirthdate: '',
        isCreatingClient: false,
        validationErrors: {},
        contactFetchTimer: null,
        contactSearchText: '',
        pendingContactQuery: '',
        reasonBlocker: "",
        conflictParams: null,
        selectedDateValue: '',
        datePickerInstance: null,
        lastQuery: ''
      }
  },
  watch: {
    date: {
      immediate: true,
      handler(newVal) {
        this.selectedDateValue = this.normalizeDate(newVal);
        if (this.datePickerInstance && this.selectedDateValue) {
          this.datePickerInstance.setDate(this.selectedDateValue, false, "Y-m-d");
        }
      }
    },
    initialTime(newVal) {
      if (newVal) this.selectedTime = newVal;
    },
    initialCategory(newVal) {
      if (newVal) this.selectedCategory = newVal;
    },
    initialService(newVal) {
      if (newVal) this.selectedService = newVal;
    },
    initialUser(newVal) {
      if (newVal) this.selectedUser = newVal;
    },
    initialClient: {
      immediate: true,
      handler(newVal) {
        if (!newVal) return;

        this.selectedContacts = {
          id: newVal.id,
          phone: newVal.phone,
          name: newVal.name,
          email: newVal.email,
        };
      }
    },
    getUsersByCategory(newVal) {
      // when users for the category are loaded, ensure selectedUser is set if initialUser provided
      if (!newVal || !this.initialUser) return;
      const found = newVal.find((u) => String(u.id) === String(this.initialUser));
      if (found) {
        this.selectedUser = this.initialUser;
      }
    },
    async selectedCategory(categoryId) {
      if (!categoryId) return;

      this.selectedService = null;
      this.selectedSubcategory = null;
      this.clearServices();
      const subcategories = await this.fetchSubcategories({ category_id: categoryId, active_only: true });
      if (!subcategories.length) {
        this.fetchAllServices({category_id: categoryId});
      }

      this.selectedUser = null;
      this.fetchUsersByCategory({category_id: categoryId});
    },
    selectedSubcategory(subcategoryId) {
      this.selectedService = null;
      if (!subcategoryId || !this.selectedCategory) return;
      this.fetchAllServices({ category_id: this.selectedCategory, subcategory_id: subcategoryId });
    },
    selectedContacts(value) {
      if (!value || !value.custom) {
        this.newClientName = '';
        this.newClientBirthdate = '';
      }
    },
    currentTab(newTab) {
      // clear fields not relevant to the other tab
      if(newTab === 'schedule'){
        this.blockEntireDay = false;
        this.blockStart = '';
        this.blockEnd = '';
        if (!this.selectedContacts && this.initialClient) {
          this.selectedContacts = {
            id: this.initialClient.id,
            phone: this.initialClient.phone,
            name: this.initialClient.name,
            email: this.initialClient.email,
          };
        }
      } else {
        // switching to block
        this.selectedTime = '';
        this.selectedContacts = null;
        this.selectedService = null;
        this.selectedPaymentMethod = null;
      }
    },

    // selectedService(serviceId) {
    //   if (!serviceId) return;

    //   this.selectedUser = null;

    //   this.fetchUsers(serviceId);
    // }
  },
  computed: {
    ...mapGetters([
      "getCategories",
      "getSubcategories",
      "getServices",
      "getUsersByCategory",
      "getUsers",
      "getContacts",
      "getPaymentMethods"
    ]),
    availableSubcategories() {
      return (this.getSubcategories || []).filter(
        (subcategory) => String(subcategory.category_id) === String(this.selectedCategory)
      );
    },
    safeDate() {
      if (!this.selectedDateValue) return null;
      return new Date(this.selectedDateValue + 'T00:00:00');
    },

    formattedDate() {
      if (!this.safeDate) return '';

      return this.safeDate.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    },

    weekDay() {
      if (!this.safeDate) return '';

      const day = this.safeDate.toLocaleDateString('pt-BR', {
        weekday: 'long'
      });

      return day.charAt(0).toUpperCase() + day.slice(1);
    }
  },
  mounted() {
    this.selectedDateValue = this.normalizeDate(this.date);
    // apply initial props if provided (in case watchers didn't run before mount)
    if (this.initialTime) this.selectedTime = this.initialTime;
    if (this.initialCategory) this.selectedCategory = this.initialCategory;
    if (this.initialService) this.selectedService = this.initialService;
    if (this.initialUser) this.selectedUser = this.initialUser;
    if (this.initialClient) {
      this.selectedContacts = {
        id: this.initialClient.id,
        phone: this.initialClient.phone,
        name: this.initialClient.name,
        email: this.initialClient.email,
      };
    }
    // if category provided, fetch related services/users
    // ensure users list is available for blocking tab (all attendants)
    this.fetchUsers(null);
    this.fetchPaymentMethods();
    if (!this.getCategories || this.getCategories.length === 0) {
      this.fetchCategories();
    }
    if (this.initialCategory) {
      this.fetchAllServices({ category_id: this.initialCategory });
      this.fetchUsersByCategory({ category_id: this.initialCategory });
    }

    if (this.allowDateSelection) {
      this.$nextTick(() => {
        this.initDatePicker();
      });
    }
  },
  unmounted() {
    if (this.datePickerInstance && typeof this.datePickerInstance.destroy === "function") {
      this.datePickerInstance.destroy();
    }
  },
  methods: {
    ...mapActions([
      "declareBilling",
      "fetchCategories",
      "fetchSubcategories",
      "fetchUsersByCategory",
      "fetchAllServices",
      "clearServices",
      "fetchUsers",
      "fetchPaymentMethods",
      "setContacts",
      "createSchedule"
    ]),
    normalizeDate(value) {
      if (!value) {
        return moment().format("YYYY-MM-DD");
      }

      const parsed = moment(value, ["YYYY-MM-DD", "DD/MM/YYYY", moment.ISO_8601], true);
      if (parsed.isValid()) {
        return parsed.format("YYYY-MM-DD");
      }

      return moment().format("YYYY-MM-DD");
    },
    initDatePicker() {
      const input = this.$refs.dateInput;
      if (!input) {
        return;
      }

      if (this.datePickerInstance && typeof this.datePickerInstance.destroy === "function") {
        this.datePickerInstance.destroy();
        this.datePickerInstance = null;
      }

      this.datePickerInstance = flatpickr(input, {
        locale: Portuguese,
        altInput: true,
        altFormat: "d/m/Y",
        dateFormat: "Y-m-d",
        defaultDate: this.selectedDateValue || null,
        minDate: "today",
        onChange: (selectedDates, dateStr) => {
          this.selectedDateValue = dateStr;
        }
      });
    },

    handleBlur() {
      // Se contato já foi selecionado, nada para fazer
      if (this.selectedContacts) {
        return;
      }

      const search = (this.contactSearchText || this.$refs.contactSelect?.search || '').trim();
      if (!search) {
        return;
      }

      const normalizedSearch = search;

      const existing = this.getContacts.find(contact =>
        String(contact.phone).replace(/\D/g, '') === String(normalizedSearch).replace(/\D/g, '') ||
        String(contact.name || '').toLowerCase() === normalizedSearch.toLowerCase()
      );

      if (existing) {
        this.selectedContacts = existing;
        this.contactSearchText = '';
        return;
      }

      this.addCustomContact(normalizedSearch);
      this.contactSearchText = '';
    },

    clearValidationErrors() {
      this.validationErrors = {};
    },

    validateSchedule() {
      this.clearValidationErrors();

      if (!this.selectedContacts) {
        this.validationErrors.selectedContacts = 'Selecione um cliente ou insira um número de telefone.';
      }
      if (!this.selectedTime) {
        this.validationErrors.selectedTime = 'Informe o horário do agendamento.';
      }
      if (!this.selectedCategory) {
        this.validationErrors.selectedCategory = 'Selecione a categoria.';
      }
      if (!this.selectedService) {
        this.validationErrors.selectedService = 'Selecione o serviço.';
      }
      if (!this.selectedUser) {
        this.validationErrors.selectedUser = 'Selecione o atendente.';
      }

      return Object.keys(this.validationErrors).length === 0;
    },

    validateBlock() {
      this.clearValidationErrors();

      if (!this.selectedUser) {
        this.validationErrors.selectedUser = 'Selecione o atendente para bloqueio.';
      }
      if (!this.blockEntireDay) {
        if (!this.blockStart) {
          this.validationErrors.blockStart = 'Informe o horário de início do bloqueio.';
        }
        if (!this.blockEnd) {
          this.validationErrors.blockEnd = 'Informe o horário de fim do bloqueio.';
        }
      }

      return Object.keys(this.validationErrors).length === 0;
    },

    addCustomContact(value) {
      const cleanPhone = value.replace(/\D/g, '');

      if (cleanPhone.length < 10) {
        alert("Número inválido");
        return;
      }

      // cria um "contato fake" compatível com o select
      this.selectedContacts = {
        phone: cleanPhone,
        name: '',
        custom: true
      };

      this.newClientName = '';
      this.newClientBirthdate = '';
    },

    formatOption(option) {
      return `${option.phone} - ${option.name ? option.name : 'Sem nome'}`;
    },

    async fetchContacts(query) {
      // Evita buscas desnecessárias
      if (!query || query.length < 2 || query === this.lastQuery) return

      this.lastQuery = query
      this.isLoading = true

      try {
        await this.setContacts(query)
      } catch (error) {
        console.error('Erro ao buscar contatos:', error)
      } finally {
        this.isLoading = false
      }
    },

    async pasteAndSearchContact() {
      try {
        if (!navigator.clipboard || typeof navigator.clipboard.readText !== 'function') {
          alert('Por questões de segurança, o seu navegador bloqueou a leitura automática. Por favor, clique no campo de busca e acesse a opção "Colar" do seu teclado ou utilize (Ctrl+V).');
          // Força o foco no input para facilitar se ele quiser colar manualmente
          if (this.$refs.contactSelect) {
            this.$refs.contactSelect.activate();
          }
          return;
        }

        const text = await navigator.clipboard.readText();
        if (!text) return;
        
        const cleanText = text.trim();
        this.contactSearchText = cleanText;

        // Atualiza a visualização e estado internos do componente multiselect
        if (this.$refs.contactSelect) {
          this.$refs.contactSelect.search = cleanText;
          
          this.$nextTick(() => {
            const inputEl = this.$refs.contactSelect.$el.querySelector('input');
            if (inputEl) {
              inputEl.value = cleanText;
              // Dispara um eveto de input para garantir total sincronia com o vue-multiselect
              inputEl.dispatchEvent(new Event('input', { bubbles: true }));
            }
          });
          
          this.$refs.contactSelect.activate();
        }

        // Realiza a busca de forma imediata (sem debounce)
        await this.fetchContacts(cleanText);
      } catch (err) {
        console.error('Falha ao colar da área de transferência', err);
        alert('Não foi possível ler a área de transferência. Verifique se o navegador possui permissão.');
      }
    },

    debouncedFetchContacts(query) {
      this.pendingContactQuery = query;
      this.contactSearchText = query;

      if (this.contactFetchTimer) {
        clearTimeout(this.contactFetchTimer);
      }

      this.contactFetchTimer = setTimeout(() => {
        this.fetchContacts(this.pendingContactQuery);
        this.contactFetchTimer = null;
      }, 800);
    },

    maskDate(event) {
      let value = event.target.value;
      value = value.replace(/\D/g, "");
      
      if (value.length > 2) {
        value = value.replace(/^(\d{2})(\d)/, "$1/$2");
      }
      if (value.length > 5) {
        value = value.replace(/^(\d{2})\/(\d{2})(\d)/, "$1/$2/$3");
      }
      
      this.newClientBirthdate = value;
      event.target.value = value;
    },

    maskTime(event){
      let value = event.target.value;

      // remove tudo que não for número
      value = value.replace(/\D/g, '');

      // limita a 4 dígitos (HHMM)
      value = value.slice(0, 4);

      // adiciona os dois pontos automaticamente
      if (value.length >= 3) {
        value = value.replace(/(\d{2})(\d+)/, '$1:$2');
      }

      event.target.value = value;
    },
    maskMoney(e) {
      let value = e.target.value;

      value = value.replace(/\D/g, "");

      if (!value) {
        this.faturamento = "";
        return;
      }

      value = (parseInt(value, 10) / 100).toFixed(2);

      value = new Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);

      this.faturamento = value;
    },
    // ensure selectedUser is set after users by category are loaded
    // this watcher uses function form to be inside methods area but will be registered via $watch in mounted if needed
    async createClientIfNeeded(){
      // Only attempt to create a client when a custom (new) contact was created via the tag feature.
      // If there's no selection or the selected contact is an existing contact (has `id`)
      // we don't need to create anything.
      if (!this.selectedContacts) {
        return true;
      }

      if (!this.selectedContacts.custom) {
        // selectedContacts exists but is not a custom tag -> assume existing contact
        return true;
      }

      const phone = (this.selectedContacts.phone || '').replace(/\D/g, '');
      if (!phone || phone.length < 10) {
        this.validationErrors.selectedContacts = 'Número de telefone inválido para cadastro de cliente.';
        return false;
      }

      const name = this.newClientName ? this.newClientName.trim() : '';
      if (!name) {
        this.validationErrors.newClientName = 'Informe o nome do cliente para cadastro.';
        return false;
      }

      if (this.newClientBirthdate && this.newClientBirthdate.length < 10) {
        this.validationErrors.newClientBirthdate = 'Data de nascimento incompleta.';
        return false;
      }

      const payload = {
        name,
        phone,
      };

      if (this.newClientBirthdate && this.newClientBirthdate.length === 10) {
        payload.birth_date = this.newClientBirthdate;
      }

      this.isCreatingClient = true;

      try {
        const response = await api.axios.post('/api/create/client', payload);

        if (response && response.data) {
          return true;
        }

        alert('Não foi possível criar o cliente. Verifique as informações e tente novamente.');
        return false;
      } catch (error) {
        console.error('Erro ao criar cliente:', error);
        const message = error?.response?.data?.message || error?.response?.data || 'Falha ao criar cliente';
        alert(message);
        return false;
      } finally {
        this.isCreatingClient = false;
      }
    },

    async confirmSchedule(){
      const isValid = this.currentTab === 'schedule' ? this.validateSchedule() : this.validateBlock();
      if (!isValid) {
        return;
      }

      this.$refs.button_submit_create_schedule.innerHTML = "Carregando...";
      this.$refs.button_submit_create_schedule.disabled = true;

      if (this.currentTab === 'schedule') {
        const clientCreated = await this.createClientIfNeeded();
        if (!clientCreated) {
          this.$refs.button_submit_create_schedule.innerHTML = `Confirmar ${this.currentTab === 'schedule' ? 'agendamento' : 'bloqueio'}`;
          this.$refs.button_submit_create_schedule.disabled = false;
          return;
        }
      }

      const params = {
        user_id: this.selectedUser,
        date: moment(this.safeDate).format("YYYY-MM-DD")
      };

      if(this.currentTab === 'schedule'){
        params.selected_time = this.selectedTime;
        params.category_id = this.selectedCategory;
        params.service_id = this.selectedService;
        params.from = (this.selectedContacts && this.selectedContacts.phone) ? this.selectedContacts.phone.replace(/\D/g, '') : '';

        if(this.selectedPaymentMethod){
          params.payment_method_id = this.selectedPaymentMethod;
        }
      } else {
        params.block = true;
        params.period = this.blockEntireDay ? '*' : `${this.blockStart}-${this.blockEnd}`;

        if(this.reasonBlocker && this.reasonBlocker.trim() !== "") {
          params.reason = this.reasonBlocker
        }
      }

      this.createSchedule(params).then((result) => {
        if (result && !result.success && result.status === 409) {
          this.$refs.button_submit_create_schedule.innerHTML = `Confirmar ${this.currentTab === 'schedule' ? 'agendamento' : 'bloqueio'}`;
          this.$refs.button_submit_create_schedule.disabled = false;
          
          this.conflictParams = params;
          this.openConflictModal();
          return;
        }

        this.$refs.button_submit_create_schedule.innerHTML = `Confirmar ${this.currentTab === 'schedule' ? 'agendamento' : 'bloqueio'}`;
        this.$refs.button_submit_create_schedule.disabled = false;
      });
    },

    openConflictModal() {
      const modalEl = document.getElementById('conflictModal');
      if (modalEl) {
        modalEl.style.display = 'block';
        setTimeout(() => modalEl.classList.add('show'), 10);
        let backdrop = document.createElement('div');
        backdrop.className = 'modal-backdrop fade show conflict-backdrop';
        backdrop.style.zIndex = '1055';
        modalEl.style.zIndex = '1060';
        document.body.appendChild(backdrop);
      }
    },

    closeConflictModal() {
      const modalEl = document.getElementById('conflictModal');
      if (modalEl) {
        modalEl.classList.remove('show');
        setTimeout(() => { modalEl.style.display = 'none'; }, 300);
      }
      const backdrop = document.querySelector('.conflict-backdrop');
      if (backdrop) backdrop.remove();
      this.conflictParams = null;
    },

    confirmWithConflict() {
      if (!this.conflictParams) return;
      
      this.$refs.button_submit_conflict.innerHTML = "Carregando...";
      this.$refs.button_submit_conflict.disabled = true;

      const params = { ...this.conflictParams, confirmConflict: true };

      this.createSchedule(params).then((result) => {
        this.$refs.button_submit_conflict.innerHTML = "Sim, criar mesmo assim";
        this.$refs.button_submit_conflict.disabled = false;
        
        if (result && result.success) {
           this.closeConflictModal();
        } else {
           alert("Falha ao forçar o agendamento conflitante. Ocorreu um erro no servidor.");
        }
      });
    }
  }
};
</script>

<style scoped>
.create-schedule-multiselect .multiselect,
.create-schedule-multiselect .multiselect__single,
.create-schedule-multiselect .multiselect__input,
.create-schedule-multiselect .multiselect__tags,
.position-relative.is-invalid .multiselect,
.position-relative.is-invalid .multiselect__single,
.position-relative.is-invalid .multiselect__input,
.position-relative.is-invalid .multiselect__tags,
.position-relative.is-invalid .multiselect__placeholder {
  border-color: #dc3545 !important;
  box-shadow: 0 0 0 .15rem rgba(220, 53, 69, .25) !important;
  color: #dc3545 !important;
}

.create-schedule-multiselect .multiselect__tags,
.position-relative.is-invalid .multiselect__tags {
  border-color: #dc3545 !important;
}

.invalid-feedback.d-block {
  display: block !important;
}
</style>
